<div class="container">
  <div class="row">
    <div class="col-12">
      <h2 class="text-center mb-5">Check your email</h2>
      <p class="mt-5 mb-4 pb-1 text--lg">We have sent an email with a verification code to сonfirm your email address. Enter this verification code below to continue creating your account.</p>
      <app-registration-withpin-confirm-form [email]="user.email"
                                   (submitEvent)="confirm($event)"
      ></app-registration-withpin-confirm-form>
    </div>
  </div>
</div>

